import { sessionState } from 'src/app/core/services/signal-state.storage';
import { DOCUMENT, Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { Us_State_prov } from 'src/app/gdo/gdo-shared/Models/Constants';
import { Theme } from 'src/app/gdo/gdo-shared/Models/Models';

@Component({
    selector: 'app-gdo-add-new-payment-options',
    templateUrl: './gdo-add-new-payment-options.component.html',
    styleUrls: ['./gdo-add-new-payment-options.component.scss'],
    standalone: false
})
export class GdoAddNewPaymentOptionsComponent implements OnInit {
  newPaymentInfoForm!: UntypedFormGroup;
  theme: Theme = 'light-theme';
  state: { paymentOptionsLength?: number } = {};
  paymentOptionsLength: number | null = null;
  stateProvDropdown = Us_State_prov;
  isDefaultPayment: boolean = false;
  isDefaultAddress: boolean = false;
  isWebView: boolean = false;
  isAcura: boolean = false;
  constructor(
    private router: Router,
    private _formBuilder: UntypedFormBuilder,
    private service: AppService,
    @Inject(DOCUMENT) private document: Document,
    private location: Location
  ) {}
  ngOnInit() {
    if (this.service.getWebviewCurrentStatus()) {
      this.isWebView = true;
    } else {
      this.isWebView = false;
    }
    this.setIsAcuraLocally();
    // this.getTheme();
    this.state = readPaymentNavigationState(this.location.getState());
    this.paymentOptionsLength = this.state.paymentOptionsLength ?? null;
    this.setDefaultPayment();
    let paymentMethodInfo = this.service.getNewPaymentMethodInfo();
    this.newPaymentInfoForm = this._formBuilder.group(
      {
        billingAddress: [
          paymentMethodInfo ? paymentMethodInfo.billingAddress : null,
          [Validators.required],
        ],
        // email: new FormControl(paymentMethodInfo ? paymentMethodInfo.email : null, [Validators.required, Validators.email]),
        //street: [paymentMethodInfo ? paymentMethodInfo.street : null, [Validators.required]],
        aptOrSuite: [paymentMethodInfo ? paymentMethodInfo.aptOrSuite : null],
        city: [
          paymentMethodInfo ? paymentMethodInfo.city : null,
          [Validators.required],
        ],
        zipCode: [
          paymentMethodInfo ? paymentMethodInfo.zipCode : null,
          [Validators.required],
        ],
        selectedState: [
          paymentMethodInfo ? paymentMethodInfo.selectedState : null,
          [Validators.required],
        ],
      },
      { validator: GdoAddNewPaymentOptionsComponent.zipCodeValidation }
    );
  }

  setDefaultPayment() {
    if (this.paymentOptionsLength === 0) {
      this.isDefaultPayment = true;
    }
  }

  trackByState(index: number, state: { value: string }): string | number {
    return state?.value || index;
  }

  getTheme() {
    this.document.body.classList.replace(
      this.theme,
      this.isAcura && this.isWebView
        ? (this.theme = 'dark-theme')
        : (this.theme = 'light-theme')
    );
  }
  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }
  // convenience getter for easy access to form fields
  onBack() {
    if (this.service.getWebviewCurrentStatus()) {
      this.router.navigate(['/gdoWV/purchase-subscription'], {
        replaceUrl: true,
      });
    } else {
      let fromSubscription = this.service.getAddingPaymentMehodFromSubscription();
      if (fromSubscription && fromSubscription == 'true') {
        this.router.navigate(['/gdo-product/manage-billing'], {
          replaceUrl: true,
        });
      } else {
        this.router.navigate(['/billing']);
      }
    }
  }

  onNext() {
    this.service.setNewPaymentMethodInfo(this.newPaymentInfoForm.value);
    if (this.service.getWebviewCurrentStatus()) {
      this.router.navigate(['/gdoWV/braintreeUiDropIn'], {
        state: {
          formData: this.newPaymentInfoForm.value,
          isDefaultAddress: this.isDefaultAddress,
          isDefaultPayment: this.isDefaultPayment,
        },
      });
    } else {
      this.router.navigate(['/billing/braintreeUiDropIn'], {
        state: {
          formData: this.newPaymentInfoForm.value,
          isDefaultAddress: this.isDefaultAddress,
          isDefaultPayment: this.isDefaultPayment,
        },
      });
    }
  }
  checkDefaultPaymentCheckBox(event: { checked: boolean }) {
    this.isDefaultPayment = event.checked;
  }
  checkDefaultAddressCheckBox(event: { checked: boolean }) {
    this.isDefaultAddress = event.checked;
  }
  static zipCodeValidation: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const zipCodeControl = control.get('zipCode');
    if (!zipCodeControl) return null;
    const zipCode = zipCodeControl.value;
    var zipUSRegex = /^\d{5}(-\d{4})?$/;
    if (!zipCode) return null;
    return zipUSRegex.test(String(zipCode)) ? null : { zipNotValid: true };
  };


}

function readPaymentNavigationState(value: unknown): { paymentOptionsLength?: number } {
  if (typeof value !== 'object' || value === null) return {};
  const paymentOptionsLength = (value as Record<string, unknown>).paymentOptionsLength;
  return typeof paymentOptionsLength === 'number' ? { paymentOptionsLength } : {};
}
